/**
 * Pixel Background — decorative dev-character sprites scattered behind content.
 * Reuses the same 10×14 grid characters from the hero sprites.
 * No interaction, no speech bubbles, no animation — purely cosmetic.
 */
(function () {
    'use strict';
    var container = document.querySelector('[data-pixel-bg]');
    if (!container) return;

    var PX = 2; // Small for dense doodle-style tiling

    // Same characters as hero sprites (palette + grid only)
    var characters = [
        {
            palette: ['transparent','#f2c9a0','#4b2e1f','#3b82f6','#1e3a8a','#93c5fd','#64748b'],
            grid: [
                [0,0,0,2,2,2,2,0,0,0],[0,0,2,2,2,2,2,2,0,0],
                [0,0,1,1,1,1,1,1,0,0],[0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],
                [0,0,3,3,3,3,3,3,0,0],[0,3,3,3,3,3,3,3,3,0],
                [0,1,3,3,3,3,3,3,1,0],[0,0,1,6,6,6,6,1,0,0],
                [0,0,0,6,6,6,6,0,0,0],[0,0,0,4,4,4,4,0,0,0],
                [0,0,0,4,0,0,4,0,0,0],[0,0,0,5,0,0,5,0,0,0]
            ]
        },
        {
            palette: ['transparent','#e8b98d','#2f2f2f','#f59e0b','#7c2d12','#fde68a','#a855f7'],
            grid: [
                [0,0,6,2,2,2,2,6,0,0],[0,6,2,2,2,2,2,2,6,0],
                [0,6,1,1,1,1,1,1,6,0],[0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],
                [0,0,3,3,3,3,3,3,0,0],[0,3,3,3,3,3,3,3,3,0],
                [0,0,3,3,3,3,3,3,0,0],[0,0,0,3,3,3,3,0,0,0],
                [0,0,0,4,4,4,4,0,0,0],[0,0,0,4,0,0,4,0,0,0],
                [0,0,0,5,0,0,5,0,0,0],[0,0,0,0,0,0,0,0,0,0]
            ]
        },
        {
            palette: ['transparent','#f0c7a4','#312e81','#8b5cf6','#4c1d95','#ddd6fe','#92400e'],
            grid: [
                [0,0,0,2,2,2,2,0,0,0],[0,0,2,2,2,2,2,2,0,0],
                [0,0,1,1,1,1,1,1,0,0],[0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],
                [0,0,3,3,3,3,3,3,0,0],[0,3,3,3,3,3,3,3,3,0],
                [0,0,3,3,3,3,1,0,0,0],[0,0,0,3,3,3,1,6,6,0],
                [0,0,0,4,4,4,0,6,6,0],[0,0,0,4,0,0,4,0,0,0],
                [0,0,0,5,0,0,5,0,0,0],[0,0,0,0,0,0,0,0,0,0]
            ]
        },
        {
            palette: ['transparent','#d9a679','#7f1d1d','#ef4444','#7f1d1d','#fecaca','#334155'],
            grid: [
                [0,0,0,2,2,2,2,0,0,0],[0,0,2,2,2,2,2,2,0,0],
                [0,0,1,1,1,1,1,1,0,0],[0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],
                [0,0,3,3,3,3,3,3,0,0],[0,3,3,3,3,3,3,1,0,0],
                [0,0,3,3,3,3,1,6,0,0],[0,0,0,3,3,3,0,6,0,0],
                [0,0,0,4,4,4,4,0,0,0],[0,0,0,4,0,0,4,0,0,0],
                [0,0,0,5,0,0,5,0,0,0],[0,0,0,0,0,0,0,0,0,0]
            ]
        },
        {
            palette: ['transparent','#cfa07a','#14532d','#22c55e','#166534','#bbf7d0','#e2e8f0'],
            grid: [
                [0,0,0,2,2,2,2,0,0,0],[0,0,2,2,2,2,2,2,0,0],
                [0,0,1,1,1,1,1,1,0,0],[0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],
                [0,0,3,3,3,3,3,3,0,0],[0,3,3,3,3,3,3,1,6,6],
                [0,0,3,3,3,3,3,0,6,6],[0,0,0,3,3,3,3,0,6,6],
                [0,0,0,4,4,4,4,0,0,0],[0,0,0,4,0,0,4,0,0,0],
                [0,0,0,5,0,0,5,0,0,0],[0,0,0,0,0,0,0,0,0,0]
            ]
        },
        {
            palette: ['transparent','#f2c9a0','#0f172a','#06b6d4','#164e63','#a5f3fc','#f59e0b'],
            grid: [
                [0,0,0,2,2,2,2,0,0,0],[0,0,2,2,2,2,2,2,0,0],
                [0,0,1,1,1,1,1,1,0,0],[0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],
                [0,0,3,3,3,3,3,3,0,0],[0,1,3,3,3,3,3,3,1,0],
                [0,0,1,6,6,6,6,1,0,0],[0,0,0,6,6,6,6,0,0,0],
                [0,0,0,4,4,4,4,0,0,0],[0,0,0,4,0,0,4,0,0,0],
                [0,0,0,5,0,0,5,0,0,0],[0,0,0,0,0,0,0,0,0,0]
            ]
        },
        {
            palette: ['transparent','#e5b38a','#78350f','#eab308','#854d0e','#fde047','transparent'],
            grid: [
                [0,0,0,2,2,2,2,0,0,0],[0,0,2,2,2,2,2,2,0,0],
                [0,0,1,1,1,1,1,1,0,0],[0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],
                [0,0,3,3,3,3,3,3,0,0],[0,3,3,3,3,3,3,3,1,0],
                [0,0,3,3,3,3,3,0,1,0],[0,0,0,3,3,3,3,0,1,0],
                [0,0,0,4,4,4,4,0,0,0],[0,0,0,4,0,0,4,0,0,0],
                [0,0,0,5,0,0,5,0,0,0],[0,0,0,0,0,0,0,0,0,0]
            ]
        },
        {
            palette: ['transparent','#e7bc96','#450a0a','#f43f5e','#881337','#fda4af','#a16207'],
            grid: [
                [0,0,0,2,2,2,2,0,0,0],[0,0,2,2,2,2,2,2,0,0],
                [0,0,1,1,1,1,1,1,0,0],[0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],
                [0,0,3,3,3,3,3,3,0,0],[0,1,6,6,6,6,6,6,1,0],
                [0,0,6,6,6,6,6,6,0,0],[0,0,6,6,6,6,6,6,0,0],
                [0,0,0,4,4,4,4,0,0,0],[0,0,0,4,0,0,4,0,0,0],
                [0,0,0,5,0,0,5,0,0,0],[0,0,0,0,0,0,0,0,0,0]
            ]
        },
        {
            palette: ['transparent','#e0b088','#365314','#84cc16','#3f6212','#d9f99d','transparent'],
            grid: [
                [0,0,0,2,2,2,2,0,0,0],[0,0,2,2,2,2,2,2,0,0],
                [0,0,1,1,1,1,1,1,0,0],[0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],
                [0,0,3,3,3,3,3,3,0,0],[0,3,3,3,3,3,3,3,3,0],
                [0,0,3,3,3,3,3,3,0,0],[0,1,0,3,3,3,3,0,1,0],
                [0,4,4,4,4,4,4,4,4,0],[0,0,4,4,4,4,4,4,0,0],
                [0,0,5,0,0,0,0,5,0,0],[0,0,0,0,0,0,0,0,0,0]
            ]
        },
        {
            palette: ['transparent','#e8bc98','#1e1b4b','#6366f1','#312e81','#c7d2fe','transparent'],
            grid: [
                [0,0,0,2,2,2,2,0,0,0],[0,0,2,2,2,2,2,2,0,0],
                [0,0,1,1,1,1,1,1,0,0],[0,0,1,2,1,1,2,1,0,0],
                [0,0,1,1,1,1,1,1,0,0],[0,0,0,1,1,1,1,0,0,0],
                [1,0,3,3,3,3,3,3,0,1],[0,1,3,3,3,3,3,3,1,0],
                [0,0,3,3,3,3,3,3,0,0],[0,0,0,3,3,3,3,0,0,0],
                [0,0,0,4,4,4,4,0,0,0],[0,0,0,4,0,0,4,0,0,0],
                [0,0,0,5,0,0,5,0,0,0],[0,0,0,0,0,0,0,0,0,0]
            ]
        }
    ];

    // Fisher-Yates shuffle
    function shuffle(arr) {
        for (var i = arr.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
        }
        return arr;
    }

    function buildSVG(char) {
        var cols = char.grid[0].length;
        var rows = char.grid.length;
        var w = cols * PX;
        var h = rows * PX;
        var rects = [];
        for (var r = 0; r < rows; r++) {
            for (var c = 0; c < cols; c++) {
                var idx = char.grid[r][c];
                if (idx === 0) continue;
                rects.push(
                    '<rect x="' + (c * PX) + '" y="' + (r * PX) +
                    '" width="' + PX + '" height="' + PX +
                    '" fill="' + char.palette[idx] + '"/>'
                );
            }
        }
        return '<svg width="' + w + '" height="' + h +
               '" viewBox="0 0 ' + w + ' ' + h +
               '" xmlns="http://www.w3.org/2000/svg" style="image-rendering:pixelated">' +
               rects.join('') + '</svg>';
    }

    shuffle(characters);

    // Dense grid tiling — WhatsApp / doodle style
    var CELL = 180; // grid cell size in px
    var JITTER = 20; // random offset within cell
    var vw = Math.max(window.innerWidth, 1400);
    var vh = Math.max(window.innerHeight * 3, 2400); // cover scrollable area
    var cols = Math.ceil(vw / CELL);
    var rows = Math.ceil(vh / CELL);
    var frag = document.createDocumentFragment();

    for (var row = 0; row < rows; row++) {
        for (var col = 0; col < cols; col++) {
            var char = characters[(row * cols + col) % characters.length];
            var el = document.createElement('div');
            el.className = 'pixel-bg__sprite';
            var x = col * CELL + Math.floor(Math.random() * JITTER);
            var y = row * CELL + Math.floor(Math.random() * JITTER);
            var flip = Math.random() < 0.3;
            var rot = [0, 0, 0, 15, -15, 10, -10][Math.floor(Math.random() * 7)];
            el.style.cssText = 'left:' + x + 'px;top:' + y + 'px;transform:' +
                (flip ? 'scaleX(-1) ' : '') + 'rotate(' + rot + 'deg)';
            el.innerHTML = buildSVG(char);
            frag.appendChild(el);
        }
    }
    container.appendChild(frag);
})();
